import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';
import { FCSelector } from '../../model/form-config.interface';
import {
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_PRODUCT_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
} from './product-capture-field-selectors.consts';

export const REFERENCE_ENTITIES: FCSelector = {
  formControlNames: [SUMMARY_PRODUCT_TYPE],
  options: [
    {
      id: 'CLN',
      logic: 'INCLUDE',
      effects: [],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_REFERENCE_ENTITIES],
          optionsLength: [
            {
              lengthLogic: 'LESS_OR_EQUAL',
              length: 1,
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  selectValues: [PERFORMANCE_TYPE_KEYS.SINGLE],
                  valid: true, // In case user selected a non-CLN product type, then selected an invalid performance type, and then switched to CLN
                },
              ],
            },
            {
              lengthLogic: 'GREATER',
              length: 1,
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  selectValues: [PERFORMANCE_TYPE_KEYS.BASKET],
                  valid: true, // In case user selected a non-CLN product type, then selected an invalid performance type, and then switched to CLN
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
